import { SearchSelectWithNestedCollapsableChildrenOptions } from './SearchSelectWithNestedCollapsableChildren.types';

// function to filter data based on search text
export const filterDataBySearch = (
	data: SearchSelectWithNestedCollapsableChildrenOptions[],
	searchTerm: string
): SearchSelectWithNestedCollapsableChildrenOptions[] => {
	if (!searchTerm.trim()) {
		return data;
	}

	return data
		.map((item) => {
			const matchesSearch = item.label.toLowerCase().includes(searchTerm.toLowerCase());
			const filteredChildren = item.children
				? filterDataBySearch(item.children, searchTerm)
				: undefined;

			// include item if it matches search or has matching children
			if (matchesSearch || (filteredChildren && filteredChildren.length > 0)) {
				return {
					...item,
					children: filteredChildren,
				};
			}
			return null;
		})
		.filter((item) => item !== null);
};

// function to get selected items with id and name from options tree
export const getSelectedItems = (
	options: SearchSelectWithNestedCollapsableChildrenOptions[],
	selectedValues: Set<string>
): Array<{ id: string; name: string }> => {
	const selectedItems: Array<{ id: string; name: string }> = [];

	const findLabels = (items: SearchSelectWithNestedCollapsableChildrenOptions[]) => {
		items.forEach((item) => {
			if (selectedValues.has(item.value)) {
				selectedItems.push({ id: item.value, name: item.label });
			}
			if (item.children) {
				findLabels(item.children);
			}
		});
	};

	findLabels(options);
	return selectedItems;
};

export const showCaretIcon = (expanded: string[], label: string) => {
	return expanded.includes(label) ? 'caret-down' : 'caret-right';
};
